// Real covers of the 6 DRUM READY volumes (WebP), same order as volumes in data/drum.ts. Empty until the volumes exist.
export const volumeCovers: string[] = [];
